import {
  EDisplayName,
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { IDREStrategy } from "../../Preferencias/strategy/preferenciasInterfaces";
import Preferencia from "../../Preferencias/strategy/Preferencia";

export default class DREStrategy implements IDREStrategy {
  createCompanies(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.empresas,
      fieldData: companies.join(","),
      displayName: EDisplayName.dREPanel,
      id: EWidgets.DREPanel
    });

    return preferencia.createPreferencesData();
  }

  createCentroDeCusto(companies: string[]): IDataPreference<string[] | string> {
    const preferencia = new Preferencia({
      fieldName: EFieldsName.centroDeCusto,
      fieldData: companies.join(","),
      displayName: EDisplayName.dREPanel,
      id: EWidgets.DREPanel
    });

    return preferencia.createPreferencesData();
  }

  createRangeInicio(filtro: string): IDataPreference<string> {
    const periodoInicio = new Preferencia({
      fieldName: EFieldsName.periodoInicio,
      fieldData: filtro[0],
      displayName: EDisplayName.dREPanel,
      id: EWidgets.DREPanel
    });

    return periodoInicio.createPreferencesData();
  }

  createRangeFim(filtro: string): IDataPreference<string> {
    const periodoFim = new Preferencia({
      fieldName: EFieldsName.periodoFim,
      fieldData: filtro[1],
      displayName: EDisplayName.dREPanel,
      id: EWidgets.DREPanel
    });

    return periodoFim.createPreferencesData();
  }
}
